/* eslint require-jsdoc: 'error', valid-jsdoc: ["error", { "requireReturn": false }] */
import Areadataset from '@fusioncharts/charts/src/dataset/area';
import { pluck, pluckNumber, getValidValue, parseUnsafeString, extend2, ZEROSTRING, getMouseCoordinate,
  HUNDREDSTRING, preDefStr, BLANK, getFirstValue, POSITION_MIDDLE,
  POSITION_BOTTOM, toRaphaelColor, POINTER, BLANKSTRING, SHAPE_RECT, parseTooltext,
  BGRATIOSTRING, hasSVG, polyPathToPath,
  convertColor, getDarkColor, getLightColor, mapSymbolName, getFirstColor, getFirstAlpha } from '@fusioncharts/core/src/lib';
import { addDep, getDep } from '@fusioncharts/core/src/dependency-manager';
import dragNodeAnimation from './dragnode-animation';
// import { triggerEvent } from '../../../core/events/event-api';
// import {_getJSONData, _restore} from './dragcolumn';
import raphaelShapesRingpath from '@fusioncharts/core/src/_internal/redraphael/redraphael-shapes/redraphael-shapes.ringpath';
import KdTree from '@fusioncharts/charts/src/dataset/_internal/kdtree';

const PADDING = 1;

let Raphael = getDep('redraphael', 'plugin'),
  UNDEF,
  mathMax = Math.max,
  mathMin = Math.min,
  CIRCLE = preDefStr.CIRCLE,
  POLYGON = preDefStr.POLYGON,
  RECTANGLE = preDefStr.RECTANGLE,
  UNDERSCORE = preDefStr.UNDERSCORE,
  GROUPID = preDefStr.GROUPID,
  EVENTARGS = preDefStr.EVENTARGS,
  OBJECTBOUNDINGBOX = preDefStr.OBJECTBOUNDINGBOX,
  DATAPLOTCLICK = 'dataplotclick',
  DATAPLOTDRAGSTART = 'dataplotdragstart',
  DATAPLOTDRAGEND = 'dataplotdragend',
  DEFAULT_CURSOR = preDefStr.DEFAULT,
  COMMA = preDefStr.COMMA,
  FIFTY_PERCENT = '50%',
  PATH = 'path',
  POLY_4 = 'poly_4',
  ROLLOVER = 'DataPlotRollOver',
  ROLLOUT = 'DataPlotRollOut',
  POSITION_TOP = preDefStr.POSITION_TOP,
  isVML = !!hasSVG,
  hideFn = function () {
    this.hide();
  },
  // CLEAR_TIME_1000 = 1000,
  // stubEvent = {
  //   pageX: 0,
  //   pageY: 0
  // },
  // animType = 'linear',
  defined = function (obj) {
    return obj !== UNDEF && obj !== null;
  },
  /**
   * Helper function of createContainer
   * @param {string} groupName The new group name
   * @param {Object} animationManager The renderer
   * @param {Object} parentContainer The container under which the new container has to be created
   * @param {Object} component The component for which the group is being created
   * @return {Object}  the newly created contaier
   */
  createGroup = (groupName, animationManager, parentContainer, component) => {
    return animationManager.setAnimation({
      el: 'group',
      attr: {
        name: groupName
      },
      container: parentContainer,
      component: component
    });
  },
  // Function that produce the point color
  getPointColor = function (colorVal, alphaVal, shapeType) {
    var color = colorVal,
      alpha = alphaVal,
      colorObj, innerColor, outerColor;
    color = getFirstColor(color);
    alpha = getFirstAlpha(alpha);
    innerColor = getLightColor(color, 80);
    outerColor = getDarkColor(color, 65);
    colorObj = {
      FCcolor: {
        gradientUnits: OBJECTBOUNDINGBOX,
        color: innerColor + COMMA + outerColor,
        alpha: alpha + COMMA + alpha,
        ratio: BGRATIOSTRING
      }
    };

    if (shapeType) {
      if (shapeType === 1) {
        colorObj.FCcolor.angle = 0;
      } else {
        colorObj.FCcolor.angle = 180;
      }
    } else {
      colorObj.FCcolor.cx = 0.4;
      colorObj.FCcolor.cy = 0.4;
      colorObj.FCcolor.r = FIFTY_PERCENT;
      colorObj.FCcolor.radialGradient = true;
    }

    return colorObj;
  },
  _configureTooltext = function (config, datasetConf, chartAttr) {
    var setTooltext = config.setTooltext,
      formatedVal = config.formatedVal,
      seriesname = datasetConf.seriesname,
      label = config.label,
      xValue = config.xValue,
      pointLabel = config.pointLabel,
      tooltipSepChar = datasetConf.tooltipSepChar,
      toolText;
    if (setTooltext !== UNDEF) {
      toolText = parseTooltext(setTooltext, [3, 4, 5, 6, 8, 9, 10, 11], {
        yaxisName: parseUnsafeString(chartAttr.yaxisname),
        xaxisName: parseUnsafeString(chartAttr.xaxisname),
        yDataValue: formatedVal,
        xDataValue: xValue,
        label: label
      }, config, chartAttr, datasetConf);
    } else if (pointLabel !== UNDEF) {
      toolText = label;
    } else { // determine the tooltext then
      if (formatedVal === null) {
        toolText = false;
      } else {
        if (datasetConf.seriesNameInToolTip) {
          seriesname = getFirstValue(datasetConf.seriesname);
        }
        toolText = seriesname ? seriesname + tooltipSepChar : BLANK;
        toolText += xValue ? xValue + tooltipSepChar : BLANK;
        toolText += formatedVal;
      }
    }
    return toolText;
  };
addDep({
  name: 'dragNodeAnimation',
  type: 'animationRule',
  extension: dragNodeAnimation
});

// Adding required shapes for chart.
raphaelShapesRingpath(Raphael);

/**
 * dataset class of dragcolumn inheriting from column class
 */
class DragNodeDataset extends Areadataset {
  /**
   * Return the name of component
   * @return {string} name
   */
  getName () {
    return 'dragNode';
  }
  /**
   * Return the type of component
   * @return {string} type
   */
  getType () {
    return 'dataset';
  }

  /**
   * Function to hide the dataset on legend click
   */
  hide () {
    var dataSet = this,
      parent = dataSet.getLinkedParent(),
      changeInfo = {};

    changeInfo.hide = true;
    dataSet.setState('dirty', true);
    dataSet.setState('visible', false);
    parent.childChanged(changeInfo);
    dataSet.getFromEnv('chart').getChildren('legend')[0].getItem(dataSet.config.legendItemId).setLegendState('hidden');
    dataSet.asyncDraw();
  }

  /**
   * Function to show the dataset on legend click
   */
  show () {
    var dataSet = this,
      parent = dataSet.getLinkedParent(),
      legendItem = dataSet.getFromEnv('legend').getItem(dataSet.config.legendItemId),
      changeInfo = {};

    changeInfo.show = true;
    dataSet.setState('visible', true);
    dataSet.setState('dirty', true);
    parent.childChanged(changeInfo);
    legendItem && legendItem.removeLegendState('hidden');
    dataSet.asyncDraw();
  }

  /**
   * Function to set the index of the dataset from amongst the other datasets
   */
  _setDatasetIndex () {
    var dataset = this,
      chidrenArr = dataset.getLinkedParent().getChildren('dataset');
    dataset.config.datasetIndex = chidrenArr.indexOf(dataset);
  }

  // Checks if a point lies in a shape
  pointInShape (x, y, config) {
    var dataset = this,
      chart = dataset.getFromEnv('chart'),
      canvas = chart.getChildren('canvas')[0],
      canvasConfig = canvas.config,
      symbol = config.symbol,
      x2,
      y2,
      r2,
      xPos = config._xPos,
      yPos = config._yPos,
      width,
      height;

    if (x < canvasConfig.canvasLeft || x > canvasConfig.canvasLeft + canvasConfig.canvasWidth ||
      y < canvasConfig.canvasTop || y > canvasConfig.canvasTop + canvasConfig.canvasHeight) {
      return false;
    }
    if (symbol === 'rectangle') {
      width = config._plotWidth;
      height = config._plotHeight;

      xPos -= width / 2;
      yPos -= height / 2;

      if (x >= xPos && y >= yPos && x <= (xPos + width) && y <= (yPos + height)) {
        return true;
      } return false;
    }
    x2 = (x - xPos) * (x - xPos);
    y2 = (y - yPos) * (y - yPos);
    r2 = Number(config.radius);

    r2 *= r2;

    if (x2 + y2 <= r2) {
      return true;
    } return false;
  }
  /**
   * This method handles all mouse events of an dataset.
   * @param {string} eventType name of the event
   * @param {number} plotIndex index of the plot where this event has been occured
   * @param {Event} e reference of the original mouse event
   * @param {number} datasetIndex index of the dataSet on which the mouse is hovered
   */
  _firePlotEvent (eventType, plotIndex, e) {
    var dataset = this,
      chart = dataset.getFromEnv('chart'),
      components = dataset.components,
      toolTipController = dataset.getFromEnv('toolTipController'),
      dataStore = components.data,
      data = dataStore[plotIndex] || {},
      sharedAnchor = dataset.getGraphicalElement('sharedAnchor'),
      setElement = (data.graphics && data.graphics.element) ||
        ((data.config && data.config.setValue) !== UNDEF && sharedAnchor),
      toolTip = this.config.currentToolTip,
      // originalEvent = e.originalEvent,
      viewMode = dataset.config.viewMode,
      groupManager = dataset.getLinkedParent(),
      config,
      ele = data.graphics.element,
      eventArgs,
      setLink;

    if (setElement) {
      config = data.config;
      setLink = config.setLink;
      eventArgs = config.eventArgs;
      switch (eventType) {
        case 'fc-mouseover' :
          dataset._decideTooltipType(plotIndex, e);
          dataset._rolloverResponseSetter(chart, data, e);
          setLink && (setElement.node.style.cursor = POINTER);
          break;
        case 'fc-mouseout' :
          toolTipController.hide(toolTip);
          dataset._rolloutResponseSetter(chart, data, e);
          setLink && (setElement.node.style.cursor = DEFAULT_CURSOR);
          break;
        case 'fc-click' :
          ele.data('fire_click_event') && chart.plotEventHandler(setElement, e, DATAPLOTCLICK, eventArgs);
          break;
        case 'fc-mousemove' :
          groupManager.hideWaitElem();
          dataset._decideTooltipType(plotIndex, e);
          break;
        case 'fc-mousedown':
          clearTimeout(ele._longpressactive);
          ele.data('fire_click_event', 1);
          if (!viewMode) {
            groupManager.drawWaitingRing(data, dataset.config.datasetIndex);
          }
          break;
        case 'fc-mouseup':
          groupManager.hideWaitElem();
          groupManager.clearLongPress();
          break;
      }
    }
  }
  /**
   * Callback function when dragging of the node is stopped
   * @param {Object} event The actual event object
   */
  dragUp (event) {
    var ele = this,
      data = ele.data('drag-options'),
      dataset = data.dataset;
    dataset._dragUp.call(ele, event);
  }

  /**
   * Callback function when a node is being dragged
   * @param {Object} event The actual event object
   * @param {Object} customData Object containing the details related to drag coordinates
   */
  dragMove (event, customData) { // eslint-disable-line no-unused-vars
    var ele = this,
      data = ele.data('drag-options'),
      dataset = data.dataset,
      dx = customData[0],
      dy = customData[1],
      px = customData[2],
      py = customData[3];
    dataset._dragMove.call(ele, dx, dy, px, py);
  }

  /**
   * Callback function when dragging of a node is started
   * @param {Object} event The actual event object
   */
  dragStart (event) {
    var ele = this,
      data = ele.data('drag-options'),
      dataset = data.dataset;
    dataset._dragStart.call(ele, event);
  }

  /**
   * Helper function of dragStart()
   * @param {Object} e The actual event object
   */
  _dragStart () {
    var element = this,
      data = element.data('drag-options'),
      dataObj = data.dataObj,
      dataGraphics = dataObj.graphics,
      ele = dataGraphics.element,
      bBox = ele.getBBox(),
      config = dataObj.config,
      dataset = data.dataset,
      chart = dataset.getFromEnv('chart'),
      sourceEvent = DATAPLOTDRAGSTART,
      dragStart = config.dragStart || (config.dragStart = {}),
      cloneGraphic = dataObj.graphics.cloneGraphic,
      cloneGraphicGroup = dataset.getContainer('cloneGraphicGroup'),
      cloneText = dataObj.graphics.cloneText,
      image = dataObj.graphics.image,
      cloneImage = dataObj.graphics.cloneImage,
      label = dataObj.graphics.label,
      eventArgs;

    // Set dirty flag to 1 so that bbox is recalculated again
    if (isVML) {
      ele._.dirty = 1;
    }

    if (config.allowDrag) {
      if (!cloneGraphic && dataObj.graphics.element) {
        cloneGraphic = dataObj.graphics.cloneGraphic = dataObj.graphics.element.clone();
        cloneGraphicGroup.appendChild(cloneGraphic);
      }
      if (label && !cloneText) {
        cloneText = dataObj.graphics.cloneText = dataObj.graphics.label.clone();
        if (cloneText.followers[0] && cloneText.followers[0].el) {
          cloneGraphicGroup.appendChild(cloneText.followers[0].el);
        }
        cloneGraphicGroup.appendChild(cloneText);
      }
      if (image && !cloneImage) {
        cloneImage = dataObj.graphics.cloneImage =
            dataObj.graphics.image.clone();
        cloneGraphicGroup.appendChild(cloneImage);
      }
      cloneText && cloneText.show();
      cloneImage && cloneImage.show();
      cloneGraphic && cloneGraphic.show();
    }
    dragStart.xPos = config._xPos;
    dragStart.yPos = config._yPos;
    dragStart.x = config.x;
    dragStart.y = config.y;
    dragStart.bBox = bBox;
    // store original x, y positions
    dragStart.origX = dragStart.lastDx || (dragStart.lastDx = 0);
    dragStart.origY = dragStart.lastDy || (dragStart.lastDy = 0);
    eventArgs = ele.data(EVENTARGS);
    // Whether to fire the click event ot not
    chart.fireChartInstanceEvent(sourceEvent, eventArgs);
    // DragNode mouse progress cursor added.
    cloneGraphic && cloneGraphic.show();
    cloneText && cloneText.show();
    cloneImage && cloneImage.show();
  }

  /**
   * Helper function of dragMove()
   * @param {number} dxVal the drag coordinates
   * @param {number} dyVal the drag coordinates
   * @param {number} px the drag coordinates
   * @param {number} py the drag coordinates
   */
  _dragMove (dxVal, dyVal) {
    var element = this,
      dx = dxVal,
      dy = dyVal,
      data = element.data('drag-options'),
      dataObj = data.dataObj,
      ele = dataObj.graphics.element,
      cloneGraphic = dataObj.graphics.cloneGraphic,
      cloneImage = dataObj.graphics.cloneImage,
      cloneText = dataObj.graphics.cloneText,
      config = dataObj.config,
      dragStart = config.dragStart,
      startX = dragStart.bBox.x + dx,
      endX = dragStart.bBox.x2 + dx,
      startY = dragStart.bBox.y + dy,
      endY = dragStart.bBox.y2 + dy,
      dataset = data.dataset,
      animationManager = dataset.getFromEnv('animationManager'),
      parent = dataset.getLinkedParent(),
      // graphics = .getContainer('waitGroup'),
      chartConfig = dataset.getFromEnv('chartConfig'),
      canvasLeft = chartConfig.canvasLeft,
      canvasRight = chartConfig.canvasRight,
      transform,
      canvasTop = chartConfig.canvasTop,
      canvasBottom = chartConfig.canvasBottom;

    // Bound limits
    if (startX < canvasLeft) {
      dx += (canvasLeft - startX);
    }
    if (endX > canvasRight) {
      dx -= (endX - canvasRight);
    }
    if (startY < canvasTop) {
      dy += (canvasTop - startY);
    }
    if (endY > canvasBottom) {
      dy -= (endY - canvasBottom);
    }
    if (dx || dy) {
      // graphics.waitElement && graphics.waitElement.hide();
      // Whether to fire the click event or not
      ele.data('fire_click_event', 0);
      parent.hideWaitElem();
      parent.clearLongPress();
    }
    if (config.allowDrag) {
      dragStart.draged = true;
      dragStart.lastDx = dx;
      dragStart.lastDy = dy;

      transform = data._transformObj = {
        transform: 't' + (dragStart.origX + dx) + COMMA +
            (dragStart.origY + dy)
      };
      if (cloneGraphic) {
        animationManager.setAnimation({
          el: cloneGraphic,
          attr: transform,
          component: dataset
        });
      }
      if (cloneImage) {
        animationManager.setAnimation({
          el: cloneImage,
          attr: transform,
          component: dataset
        });
      }
      if (cloneText) {
        animationManager.setAnimation({
          el: cloneText,
          attr: {
            x: config._xPos + dx,
            y: config._yPos + dy
          },
          component: dataset
        });
      }
    }
  }

  /**
   * Function that return the nearest plot details
   * @param   {number} x x-axis position of the mouse cordinate
   * @param   {number} y y-axis position of the mouse cordinate
   * @return {Object} return an object with details of nearest plot and whether it is
   *                   hovered or not
   */
  _getHoveredPlot (x, y) {
    var res = this.config.tree.getNeighbour({
      x: x,
      y: y
    }, false);
    // searching neighbour from Kdtree with basic search flag on
    if (res) {
      return {
        pointIndex: res.index || res.i,
        hovered: true,
        pointObj: res.data
      };
    }
  }
  /**
   * handler called on mouseout
   *
   * @param {any} chart chart
   * @param {any} data dataObj on which event occured
   * @param {any} e event
   * @memberof DragNodeDataset
   */
  _rolloutResponseSetter (chart, data, e) {
    var dataset = this,
      animationManager = dataset.getFromEnv('animationManager'),
      config = data.config,
      element = data.graphics.element,
      dragStart = config.dragStart,
      unHoverAttr = element.data('unHoverAttr'),
      keysNo = dragStart && Object.keys(dragStart).length;

    if (!keysNo) {
      if (config.shapeType === 'poly' || config.shapeType === CIRCLE) {
        // For polygon and circle, convert path to polypath
        unHoverAttr.path = polyPathToPath([config.shapeArg.sides, config._xPos, config._yPos, unHoverAttr.r, config.startAngle, 0]);
      }
      config.rollOverProperties.enabled && animationManager.setAnimation({
        el: element,
        attr: unHoverAttr,
        component: dataset
      });
      chart && chart.plotEventHandler(element, e, ROLLOUT);
    }
  }

  /**
   * handler called on mouseover
   *
   * @param {any} chart chart
   * @param {any} data dataObj on which event occured
   * @param {any} e event
   * @memberof DragNodeDataset
   */
  _rolloverResponseSetter (chart, data, e) {
    var dataset = this,
      animationManager = dataset.getFromEnv('animationManager'),
      config = data.config,
      element = data.graphics.element,
      dragStart = config.dragStart,
      hoverAttr = element.data('hoverAttr'),
      keysNo = dragStart && Object.keys(dragStart).length;

    if (!keysNo) {
      if (config.shapeType === 'poly' || config.shapeType === CIRCLE) {
        // For polygon and circle, convert path to polypath
        hoverAttr.path = polyPathToPath([config.shapeArg.sides, config._xPos, config._yPos, hoverAttr.r, config.startAngle, 0]);
      }
      config.rollOverProperties.enabled && animationManager.setAnimation({
        el: element,
        attr: hoverAttr,
        component: dataset
      });
      chart && chart.plotEventHandler(element, e, ROLLOVER);
    }
  }
  /**
   * Helper function of dragUp()
   * @param {Object} event The actual event object
   */
  _dragUp (event) {
    var element = this,
      data = element.data('drag-options'),
      dataset = data.dataset,
      // chartConfig = dataset.getFromEnv('chartConfig'),
      chart = dataset.getFromEnv('chart'),
      dataStore = dataset.components.data,
      dataObj = data.dataObj,
      ele = dataObj.graphics.element,
      groupManager = dataset.getLinkedParent(),
      startConnectors,
      endConnectors,
      sourceEvent = DATAPLOTDRAGEND,
      config = dataObj.config,
      // canvasTop = chartConfig.canvasTop,
      // canvasLeft = chartConfig.canvasLeft,
      dragStart = dataObj.config.dragStart || {},
      yAxis = dataset.getFromEnv('yAxis'),
      i,
      setObj,
      len,
      eventCord,
      eventArgs,
      cloneText = dataObj.graphics.cloneText,
      // graphics = dataset.groupManager.graphics,
      xAxis = dataset.getFromEnv('xAxis'),
      updateObj = {},
      datasetIndex = dataset.config.datasetIndex,
      cloneGraphic = dataObj.graphics.cloneGraphic,
      cloneImage = dataObj.graphics.cloneImage;

    groupManager.hideWaitElem();
    groupManager.clearLongPress();
    if (dragStart.draged) {
      dragStart.origX += dragStart.lastDx;
      dragStart.origY += dragStart.lastDy;
      dataObj.config._xPos = dragStart.xPos + dragStart.lastDx;
      dataObj.config._yPos = dragStart.yPos + dragStart.lastDy;
      updateObj.x = xAxis.getValue(dataObj.config._xPos);
      updateObj.y = yAxis.getValue(dataObj.config._yPos);
      updateObj.update = true;
      for (i = 0, len = dataStore.length; i < len; i++) {
        setObj = dataStore[i];
        if (dataObj.config.id === setObj.config.id) {
          break;
        }
      }

      dataset.updatePointConfig(updateObj, i);
      eventArgs = ele.data(EVENTARGS);
      eventArgs.x = updateObj.x;
      eventArgs.y = updateObj.y;
      dataset.parsePlotAttributes(i);
      dataset._drawNode(i);
      // dataset.drawTracker(i, i + 1);
      startConnectors = dataObj.config.startConnectors;
      endConnectors = dataObj.config.endConnectors;
      groupManager.drawNodeConnectors(startConnectors, datasetIndex);
      groupManager.drawNodeConnectors(endConnectors, datasetIndex);
      eventCord = getMouseCoordinate(chart.getFromEnv('chart-container'), event, chart);
      eventCord.sourceEvent = sourceEvent;
      // Fire the ChartUpdated event
      chart.fireChartInstanceEvent('chartupdated', extend2({
        sourceEvent: sourceEvent
      }, eventArgs), event);
      chart.fireChartInstanceEvent(sourceEvent, eventArgs, event);
      dragStart.draged = false;
      dataset._setupKdTree();
    }
    cloneText && cloneText.hide();
    cloneGraphic && cloneGraphic.hide();
    cloneImage && cloneImage.hide();
    delete config.dragStart;
  }

  /**
   * Function to update a specific node at the end of dragging
   * @param {Object} updateConf Having values regarding the new position of the node
   * @param {number} index the index of the node that is to be updated
   */
  updatePointConfig (updateConf, index) {
    var dataset = this,
      // chart = dataset.chart,
      dataStore = dataset.components.data,
      conf = dataset.config,
      dataObj = dataStore[index] || {},
      config = dataObj.config,
      numberFormatter = dataset.getFromEnv('number-formatter'),
      chartAttr = dataset.getFromEnv('chart-attrib'),
      // yMin = conf.yMin || +Infinity,
      // yMax = conf.yMax || -Infinity,
      // xMax = conf.xMax || -Infinity,
      // xMin = conf.xMin || +Infinity,
      xValue;
    if (config === UNDEF) {
      return;
    }
    config.y = numberFormatter.getCleanValue(pluck(updateConf.y));
    config.x = numberFormatter.getCleanValue(pluck(updateConf.x));
    config._options.x = config.x;
    config._options.y = config.y;
    // yMax = mathMax(yMax, config.y);
    // yMin = mathMin(yMin, config.y);
    // xMax = mathMax(xMax, config.x);
    // xMin = mathMin(xMin, config.x);
    xValue = numberFormatter.xAxis(config.x);
    // push the point object
    config.formatedVal = (config.y === null
      ? config.y : numberFormatter.dataLabels(config.y));
    config.xValue = xValue;
    if (!conf.showTooltip) {
      config.toolText = false;
    } else {
      config.toolText = _configureTooltext(config, conf, chartAttr);
    }
    config.update = updateConf.update;
  }

  /**
   * Returns a node corresponding to the given id
   * @param {string} id The id of the enquired node
   * @return {Object} The object conatining the info about the node
   */
  getNode (id) {
    return id ? this.components.nodes[id] : this.components.nodes;
  }

  /**
    * Function for parsing all the attributes and value given by the user at chart and dataset level.
    * This function is called once from the init() function of the Column class.
    * @param  {Object} datasetJSON JSON for dataset configurations
    * @return {boolean} if no datasetJSON is found
    */
  configureAttributes (datasetJSON) {
    if (datasetJSON) {
      this.trimData(datasetJSON);
      this.config.JSONData = datasetJSON;
    } else if (!datasetJSON && !this.config.JSONData) {
      return false;
    }

    var dataset = this,
      dIndex = dataset.config.datasetIndex,
      JSONData = dataset.config.JSONData,
      data = JSONData.data || [],
      chartAttr = dataset.getFromEnv('chart-attrib'),
      chartConfig = dataset.getFromEnv('chartConfig'),
      dataLength = data.length,
      conf = dataset.config,
      // showValues,
      ZERO = ZEROSTRING,
      colorM = dataset.getFromEnv('color-manager'),
      index,
      plotFillAlpha,
      showPlotBorder,
      plotBorderColor,
      plotBorderThickness,
      plotBorderAlpha,
      // datasetId,
      datasetPlotBorderThickness,
      // dataStore,
      // dataStoreLen,
      useRoundEdges,
      HUNDRED = HUNDREDSTRING;
    conf.context = {};
    dataset.components.nodes = {};
    conf.showValues = pluckNumber(JSONData.showvalues, chartAttr.showvalues, 1);
    useRoundEdges = conf.useRoundEdges = pluckNumber(chartAttr.useroundedges);
    conf.zIndex = 1;
    conf.name = getValidValue(JSONData.seriesname);
    conf.viewMode = pluckNumber(chartAttr.viewmode, 0);
    conf.id = pluck(JSONData.id, dataset.index);
    if (pluckNumber(JSONData.includeinlegend) === 0 ||
      conf.name === UNDEF) {
      conf.showInLegend = false;
    }
    conf.seriesname = parseUnsafeString(JSONData.seriesname);
    conf.includeinlegend = pluckNumber(JSONData.includeinlegend, (conf.seriesname ? 1 : 0));

    conf.showTooltip = pluckNumber(chartAttr.showtooltip, 1);
    conf.seriesNameInTooltip = pluckNumber(chartAttr.seriesnameintooltip, 1);
    conf.showTextOutline = pluckNumber(chartAttr.textoutline, 0);
    conf.tooltipSepChar = pluck(chartAttr.tooltipsepchar, ' - ');
    // Plot Properties
    plotFillAlpha = conf.plotFillAlpha = pluck(chartAttr.plotfillalpha, HUNDRED);
    showPlotBorder = conf.showPlotBorder = pluckNumber(chartAttr.showplotborder, 1);
    plotBorderColor = conf.plotBorderColor = getFirstColor(pluck(chartAttr.plotbordercolor, '666666'));
    plotBorderThickness = conf.plotBorderThickness = pluckNumber(chartAttr.plotborderthickness,
      useRoundEdges ? 2 : 1);
    plotBorderAlpha = conf.plotBorderAlpha = pluck(chartAttr.plotborderalpha, chartAttr.plotfillalpha,
      useRoundEdges ? '35' : '95');

    // Node Properties
    conf.use3DLighting = Boolean(pluckNumber(chartAttr.use3dlighting,
      chartAttr.is3d, useRoundEdges ? 1 : 0));
    // Store attributeshc
    conf.color = getFirstColor(pluck(JSONData.color, colorM.getPlotColor(dIndex)));
    conf.alpha = pluck(JSONData.plotfillalpha, JSONData.nodeFillAlpha,
      JSONData.alpha, plotFillAlpha);
    // Data set plot properties
    conf.datasetShowPlotBorder = Boolean(pluckNumber(JSONData.showplotborder, showPlotBorder));
    conf.datasetPlotBorderColor = getFirstColor(pluck(JSONData.plotbordercolor, JSONData.nodebordercolor,
      plotBorderColor));
    conf.datasetPlotBorderThickness = pluckNumber(JSONData.plotborderthickness,
      JSONData.nodeborderthickness, plotBorderThickness);
    conf.datasetPlotBorderAlpha = (conf.datasetShowPlotBorder) ? pluck(JSONData.plotborderalpha,
      JSONData.nodeborderalpha, JSONData.alpha, plotBorderAlpha) : ZERO;
    // Drag Border properties
    conf.datasetAllowDrag = Boolean(pluckNumber(JSONData.allowdrag, 1));

    conf.colorObj = {
      fillColor: convertColor(conf.color, conf.alpha),
      lineColor: {
        FCcolor: {
          color: conf.datasetPlotBorderColor,
          alpha: conf.datasetPlotBorderAlpha
        }
      }
    };
    conf.lineWidth = datasetPlotBorderThickness;
    conf.symbol = POLY_4;
    // dataStore = dataset.components.data =
    dataset.components.data || (dataset.components.data = []);
    // dataStoreLen = dataStore.length;
    // if (dataStoreLen > dataLength) {
    //   dataStore.splice(dataLength, dataStoreLen - dataLength);
    // }

    dataset.setState('visible', pluckNumber(JSONData.visible,
      !Number(JSONData.initiallyhidden), 1) === 1);
    conf.yMin = conf.yMax = conf.xMax = conf.xMin = 0;
    // This flag is true when data update is fired
    dataset._refreshData = true;
    // Iterate through all level data
    for (index = 0; index < dataLength; index += 1) {
      this._setConfigure(index);
    }
    dataset._refreshData = false;
    chartConfig.showLegend && dataset._addLegend();
    dataset._setDatasetIndex();
    dataset.setState('dirty', true);
  }

  /**
   * Function for parsing all the attributes and value given by the user at set level.
   * @param {number} index The data index for which the configuration is to be prsed.
   * @param {Object} updateObj It has the information of the data given by the user
   */
  _setConfigure (index, updateObj) {
    var dataset = this,
      JSONData = dataset.config.JSONData,
      data = JSONData.data,
      setData = updateObj || data[index],
      dataStore = dataset.components.data,
      conf = dataset.config,
      dataObj = dataStore[index] = dataStore[index] || (dataStore[index] = {}),
      config = dataObj.config = dataObj.config || (dataObj.config = {}),
      datasetId = conf.id,
      shape,
      yMin = conf.yMin || +Infinity,
      yMax = conf.yMax || -Infinity,
      xMax = conf.xMax || -Infinity,
      xMin = conf.xMin || +Infinity,
      itemValueY,
      itemValueX,
      label,
      safeLabel,
      shapeType,
      use3DLighting = conf.use3DLighting,
      datasetPlotBorderThickness = conf.datasetPlotBorderThickness,
      datasetPlotBorderColor = conf.datasetPlotBorderColor,
      datasetPlotBorderAlpha = conf.datasetPlotBorderAlpha,
      // chart = dataset.chart,
      chartAttr = dataset.getFromEnv('chart-attrib'),
      datasetColor = conf.color,
      datasetAlpha = conf.alpha,
      // fillColor,
      datasetAllowDrag = conf.datasetAllowDrag,
      numberFormatter = dataset.getFromEnv('number-formatter');

    !dataObj.graphics && (dataObj.graphics = {});
    config._options = extend2({}, setData);
    if (setData || updateObj) {
      itemValueY = config.y = numberFormatter.getCleanValue(pluck(setData.y));
      itemValueX = config.x = numberFormatter.getCleanValue(pluck(setData.x));
      config.index = index;
      if (!config.dragStart) {
        config.dragStart = {};
      }
      yMax = mathMax(yMax, config.y);
      yMin = mathMin(yMin, config.y);
      xMax = mathMax(xMax, config.x);
      xMin = mathMin(xMin, config.x);
      if (itemValueY === null) {
        config.value = null;
      } else {
        label = numberFormatter.xAxis(itemValueX);
        // push the point object
        config.formatedVal = (itemValueY === null
          ? itemValueY : numberFormatter.dataLabels(itemValueY));
        config.setTooltext = getValidValue(parseUnsafeString(pluck(setData.tooltext,
          JSONData.plottooltext, chartAttr.plottooltext), false));
        config.pointLabel = pluck(setData.label, setData.name);
        safeLabel = parseUnsafeString(config.pointLabel);
        config.label = safeLabel;
        config.name = safeLabel;
        config.displayValue = safeLabel;
        config.xValue = label;
        if (!updateObj) {
          config.startConnectors = {};
          config.endConnectors = {};
        }
        // create the tooltext
        if (!conf.showTooltip) {
          config.toolText = false;
        } else {
          config.toolText = _configureTooltext(config, conf, chartAttr);
        }
        config.link = setData.link;
        // Shape and cosmetics related attributes
        config.id = pluck(setData.id, (datasetId + preDefStr.UNDERSCORE + index));
        config.allowDrag = Boolean(pluckNumber(setData.allowdrag, datasetAllowDrag));
        shape = config.shape = getValidValue(pluck(setData.shape), preDefStr.RECTANGLE).toLowerCase();
        config.height = getValidValue(pluck(setData.height), 10);
        config.width = getValidValue(pluck(setData.width), 10);
        config.radius = getValidValue(pluck(setData.radius), 10);
        config.numSides = getValidValue(pluck(setData.numsides), 4);
        config.color = getFirstColor(pluck(setData.color, datasetColor));
        config.borderColor = getFirstColor(pluck(setData.bordercolor, datasetPlotBorderColor));
        config.alpha = pluck(setData.alpha, datasetAlpha);
        config.imageURL = getValidValue(setData.imageurl);
        config.imageNode = Boolean(pluckNumber(setData.imagenode));
        config.imageWidth = setData.imagewidth;
        config.imageHeight = setData.imageheight;
        config.imageAlign = getValidValue(setData.imagealign, BLANK).toLowerCase();
        config.labelAlign = pluck(setData.labelalign, config.imageNode &&
            defined(config.imageURL) ? POSITION_TOP : preDefStr.POSITION_MIDDLE);
        config.hovercolor = pluck(setData.hovercolor, JSONData.hovercolor);
        config.borderhoveralpha = pluck(setData.borderhoveralpha, JSONData.borderhoveralpha);
        config.borderhovercolor = pluck(setData.borderhovercolor, JSONData.borderhovercolor);
        config.borderhoverthickness = pluck(setData.borderhoverthickness, JSONData.borderhoverthickness);
        config.hoveralpha = pluck(setData.hoveralpha, JSONData.hoveralpha);
        config.hoverheight = pluck(setData.hoverheight, JSONData.hoverheight);
        config.hoverradius = pluck(setData.hoverradius, JSONData.hoverradius);
        config.hoverwidth = pluck(setData.hoverwidth, JSONData.hoverwidth);

        config.dataLabelStyle = dataset._configureDataLabelStyle(setData);
        // If not required shape then set it to rectangle
        switch (config.shape) {
          case CIRCLE:
            shapeType = 0;
            break;
          case POLYGON:
            shapeType = 2;
            shape = mapSymbolName(config.numSides);
            break;
          default:
            shapeType = 1;
            break;
        }
        config.symbol = shape;
        if (use3DLighting) {
          config.fillColor = getPointColor(config.color,
            config.alpha, shapeType);
          config.cloneFillColor = getPointColor(config.color, 50, shapeType);
        } else {
          config.fillColor = {
            color: config.color,
            alpha: config.alpha
          };
          config.cloneFillColor = convertColor(config.color, 50);
        }
        config.colorArr = [
          {
            FCcolor: {
              color: config.color,
              alpha: config.alpha
            }
          },
          {
            FCcolor: {
              color: config.borderColor,
              alpha: datasetPlotBorderAlpha
            }
          }
        ];
        config.rollOverProperties = dataset.pointHoverOptions(dataObj, chartAttr, {
          shapeType: shapeType,
          use3D: use3DLighting,
          height: config.height,
          width: config.width,
          radius: config.radius,
          color: config.color,
          alpha: config.alpha,
          borderColor: config.borderColor,
          borderAlpha: datasetPlotBorderAlpha,
          borderThickness: datasetPlotBorderThickness
        });
      }
      !config.update && updateObj && (config.update = updateObj.update);
      !config.add && updateObj && (config.add = updateObj.add);
      if (dataset._refreshData === true) {
        delete dataObj.removed;
      }
    }
    dataObj.dataset = dataset;
    conf.xMax = xMax;
    conf.xMin = xMin;
    conf.yMin = yMin;
    conf.yMax = yMax;
  }

  /**
   * Function for parsing the hover effects
   * @param {Object} dataObj Containing the set level information used for creating the hover effect
   * @param {Object} chartAttr Containing the chart level information used for creating the hover effect
   * @param {Object} defaults Containing the default information used for creating the hover effect
   * @return {Object} Containg the final parsed hover properties
   */
  pointHoverOptions (dataObj, chartAttr, defaults) {
    var dataset = this,
      hoverEffect = pluckNumber(dataObj.config.showhovereffect, dataset.config.showhovereffect,
        chartAttr.plothovereffect, chartAttr.showhovereffect),
      rolloverProperties = {},
      hoverAttr = !!pluck(dataObj.config.hovercolor, dataset.config.hovercolor, chartAttr.plotfillhovercolor,
        dataObj.config.hoveralpha, dataset.config.hoveralpha, chartAttr.plotfillhoveralpha,
        dataObj.config.borderhovercolor, dataset.config.borderhovercolor, chartAttr.plotborderhovercolor,
        dataObj.config.borderhoveralpha, dataset.config.borderhoveralpha, chartAttr.plotborderhoveralpha,
        dataObj.config.borderhoverthickness, dataset.config.borderhoverthickness, chartAttr.plotborderhoverthickness,
        dataObj.config.hoverheight, dataset.config.hoverheight, chartAttr.plothoverheight,
        dataObj.config.hoverwidth, dataset.config.hoverwidth, chartAttr.plothoverwidth,
        dataObj.config.hoverradius, dataset.config.hoverradius, chartAttr.plothoverradius, hoverEffect),
      enabled = false,
      color,
      alpha,
      rawhoverBorderColor,
      rawhoverBorderAlpha,
      fillColor;

    if ((hoverEffect === UNDEF && hoverAttr) || hoverEffect) {
      enabled = true;
      color = pluck(dataObj.config.hovercolor, dataset.config.hovercolor,
        chartAttr.plotfillhovercolor, getLightColor(defaults.color, 70));
      alpha = pluck(dataObj.config.hoveralpha, dataset.config.hoveralpha,
        chartAttr.plotfillhoveralpha, defaults.alpha);
      rawhoverBorderColor = pluck(dataObj.config.borderhovercolor, dataset.config.borderhovercolor,
        chartAttr.plotborderhovercolor, defaults.borderColor);
      rawhoverBorderAlpha = pluckNumber(dataObj.config.borderhoveralpha, dataset.config.borderhoveralpha,
        chartAttr.plotborderhoveralpha, alpha, defaults.borderAlpha);

      rolloverProperties = {
        rawhoverAlpha: alpha,
        rawhoverColor: color,
        rawhoverBorderColor,
        rawhoverBorderAlpha,
        stroke: convertColor(rawhoverBorderColor,
          pluckNumber(dataObj.config.borderhoveralpha, dataset.config.borderhoveralpha,
            chartAttr.plotborderhoveralpha, alpha, defaults.borderAlpha)),
        'stroke-width': pluckNumber(dataObj.config.borderhoverthickness, dataset.config.borderhoverthickness,
          chartAttr.plotborderhoverthickness, defaults.borderThickness),
        height: pluckNumber(dataObj.config.hoverheight, dataset.config.hoverheight,
          chartAttr.plothoverheight, defaults.height),
        width: pluckNumber(dataObj.config.hoverwidth, dataset.config.hoverwidth,
          chartAttr.plothoverwidth, defaults.width),
        r: pluckNumber(dataObj.config.hoverradius, dataset.config.hoverradius,
          chartAttr.plothoverradius, defaults.radius)
      };

      if (defaults.use3D) {
        fillColor = getPointColor(getFirstColor(pluck(dataObj.config.hovercolor,
          dataset.config.hovercolor, chartAttr.plotfillhovercolor,
          getLightColor(defaults.color, 70))),
        pluck(dataObj.config.hoveralpha, dataset.config.hoveralpha,
          chartAttr.plotfillhoveralpha, defaults.alpha),
        defaults.shapeType);
      } else {
        fillColor = convertColor(color, alpha);
      }

      rolloverProperties.fill = toRaphaelColor(fillColor);
    }

    return {
      enabled: enabled,
      rollOverAttrs: rolloverProperties
    };
  }

  /**
   * Function for attaching a legend with a dataset
   */
  _addLegend () {
    var dataset = this,
      // chart = dataset.chart,
      conf = dataset.config,
      legendItem,
      legend = dataset.getFromEnv('legend'),
      config = {
        enabled: conf.includeInLegend,
        type: dataset.type,
        anchorSide: 4,
        label: getFirstValue(dataset.config.JSONData.seriesname)
      };
    if (conf.includeinlegend) {
      legendItem = legend.getItem(dataset.config.legendItemId);
      if (!legendItem) {
        dataset.config.legendItemId = legend.createItem(dataset);
        legendItem = legend.getItem(dataset.config.legendItemId);
        dataset.addExtEventListener('fc-click', function () {
          legendItem.itemClickFn();
        }, legendItem);
      } else {
        legendItem.configure({ style: legend.config.itemStyle,
          hiddenStyle: legend.config.itemHiddenStyle,
          datasetVisible: legend.config.datasetVisible,
          hoverStyle: legend.config.itemHoverStyle });
      }
      legendItem.configure(config);
      legendItem.setStateCosmetics('default', {
        symbol: {
          fill: toRaphaelColor({
            color: conf.color,
            alpha: conf.alpha
          }),
          rawFillColor: conf.color,
          stroke: toRaphaelColor({
            color: conf.plotBorderColor,
            alpha: HUNDREDSTRING
          }),
          'stroke-width': conf.anchorBorderThickness
        }
      });
      // check if dataset is initiallyhidden
      if (!dataset.getState('visible')) {
        legendItem.setLegendState('hidden');
      } else { // remove hidden state of legend item is dataset is not hidden
        legendItem.removeLegendState('hidden');
      }
    } else if (dataset.config.legendItemId) {
      legend.disposeItem(dataset.config.legendItemId);
    }
  }

  /**
   * Function to create graphical container for the specific dataset
   */
  createContainer () {
    var dataset = this,
      animationManager = dataset.getFromEnv('animationManager'),
      parentContainer = dataset.getLinkedParent().getChildContainer();

    !dataset.getContainer('nodesGroup') && dataset.addContainer('nodesGroup',
      createGroup('nodesGroup', animationManager, parentContainer.defaultVcanvasGroup, dataset));

    !dataset.getContainer('dataLabelsGroup') && dataset.addContainer('dataLabelsGroup',
      createGroup('dataLabelsGroup', animationManager, parentContainer.vcanvasLabelGroup, dataset));

    !dataset.getContainer('cloneGraphicGroup') && dataset.addContainer('cloneGraphicGroup',
      createGroup('cloneGraphicGroup', animationManager, parentContainer.defaultVcanvasGroup, dataset));
  }

  /**
   * Draw function of DragNodeDataset
   */
  draw () {
    var dataset = this,
      components = dataset.components,
      // parent = dataset.getLinkedParent(),
      // datasetGraphics = parent.getChildContainer(),
      // chart = dataset.chart,
      // jobList = chart.getJobList(),
      smartLabel = dataset.getFromEnv('smartLabel'),
      data = components.data,
      removeDataArr = dataset.components.removeDataArr || [],
      removeDataArrLen = removeDataArr.length,
      i,
      // paper = dataset.getFromEnv('paper'),
      ln,
      group,
      // config,
      style = dataset.getFromEnv('dataLabelStyle'),
      css = {
        fontFamily: style.fontFamily,
        fontSize: style.fontSize,
        lineHeight: style.lineHeight,
        fontWeight: style.fontWeight,
        fontStyle: style.fontStyle
      },
      // dragLabelGroup,
      removed;
      // layers = chart.graphics, // requird for series
      // gDataset = layers.datasetGroup;

    if (!dataset.getState('dirty') && !dataset._contextChanged()) {
      return;
    }
    dataset.createContainer();
    group = dataset.getContainer('nodesGroup');
    // dragLabelGroup = dataset.getContainer('dataLabelsGroup');
    dataset.getFromEnv('animationManager').setAnimation({
      el: dataset.getContainer('cloneGraphicGroup'),
      attr: { opacity: 0.3 },
      component: dataset
    });

    group.css(css);
    smartLabel.useEllipsesOnOverflow(dataset.getFromEnv('chartConfig').useEllipsesWhenOverflow);
    // smartLabel.setStyle(style);
    // group.css(css);
    // draw data
    for (i = 0, ln = data.length; i < ln; i += 1) {
      // config = data[i].config;
      removed = data[i].removed;
      !removed && this._drawNode(i);
    }
    dataset.config.drawn = true;

    // if (dataset.visible) {
    //   group.show();
    //   // dragLabelGroup.show();
    // }
    // Remove the extra elements
    for (i = 0; i < removeDataArrLen; i++) {
      dataset._removeDataVisuals(removeDataArr.shift());
    }
    dataset._setupKdTree();
  }

  /**
   * Sets up kdtree for finding out whether pointer is above any plot
   *
   * @memberof DragNodeDataset
   */
  _setupKdTree () {
    var dataset = this,
      conf = dataset.config,
      data = dataset.components.data,
      dataLen,
      i,
      config,
      attr,
      maxRadius = -Infinity,
      searchDataArr;

    searchDataArr = conf.searchDataArr = [];
    dataLen = data.length;
    for (i = 0; i < dataLen; i++) {
      config = data[i].config;
      if (!data[i].removed && config._yPos !== UNDEF && !isNaN(config._yPos)) {
        attr = config.props.element.attr;
        maxRadius = Math.max(maxRadius, pluckNumber(config.radius, 0));
        searchDataArr.push({
          x: pluckNumber(attr.x, config._xPos),
          y: pluckNumber(attr.y, config._yPos),
          index: i,
          data: data[i],
          shapeInfo: {
            type: config.shape,
            radius: pluck(config.radius, 0),
            width: pluckNumber(config.width),
            height: pluckNumber(config.height),
            sides: pluckNumber(config.numSides)
          }
        });
      }
    }
    conf.tree = new KdTree(true).buildKdTree(searchDataArr);
    conf.tree._setSearchLimit(maxRadius, maxRadius);
  }
  /**
   * Draw the individual data labels for the nodes
   * @param {number} index The index of the datalabel that is to be drawn
   */
  drawLabel (index) {
    var dataset = this,
      chart = dataset.getFromEnv('chart'),
      conf = dataset.config,
      datasetIndex = conf.datasetIndex,
      animationManager = dataset.getFromEnv('animationManager'),
      dataStore = dataset.components.data,
      i,
      len = dataStore.length,
      labelAttrs,
      labelElement,
      plotLabelStyle,
      group = dataset.getContainer('nodesGroup'),
      // style = chart.config.dataLabelStyle,
      // animationObj = chart.get('config', 'animationObj'),
      // dummyAnimElem = animationObj.dummyObj,
      // dummyAnimObj = animationObj.animObj,
      config,
      valueString,
      chartConfig = dataset.getFromEnv('chartConfig'),
      style = dataset.getFromEnv('dataLabelStyle'),
      cursor,
      smartTextObj,
      labelDisplacement,
      eventArgs,
      set,
      yAdjustment,
      // animType = animationObj.animType,
      xPos,
      labelY,
      groupId,
      cloneText,
      plotWidth,
      plotHeight,
      labelAlign,
      setGraphics,
      dragUp = dataset.dragUp,
      dragMove = dataset.dragMove,
      dragStart = dataset.dragStart,
      rollOverProperties,
      shapeType,
      yPos,
      smartLabel = dataset.getFromEnv('smartLabel'),
      setElement,
      visible = dataset.getState('visible');

    smartLabel.setStyle(style);

    if (index !== UNDEF) {
      i = index;
      len = i + 1;
    } else {
      i = 0;
    }

    for (; i < len; i++) {
      set = dataStore[i];
      config = set.config;
      plotWidth = config._plotWidth;
      plotHeight = config._plotHeight;
      valueString = config.displayValue;
      labelAlign = config.labelAlign;
      setGraphics = set.graphics;
      cloneText = setGraphics.cloneText;
      rollOverProperties = set.config.rollOverProperties;
      shapeType = config.shapeType;

      if (visible && defined(valueString) && valueString !== BLANK) {
        // Get the displayValue text according to the canvas width.
        smartLabel.useEllipsesOnOverflow(chartConfig.useEllipsesWhenOverflow);
        // padding for text from boundaries is taken care of
        smartTextObj = smartLabel.getSmartText(valueString,
          plotWidth - PADDING, plotHeight - PADDING);

        // label displacement for top or bottom
        labelDisplacement = plotHeight * 0.5 -
            (smartTextObj.height * 0.5);
        // label at TOP
        switch (labelAlign) {
          case POSITION_TOP:
            labelDisplacement = -labelDisplacement;
            break;
          case POSITION_BOTTOM:
            break;
          default:
            labelDisplacement = 0;
            break;
        }
        xPos = config._xPos;
        yPos = config._yPos;
        set._yAdjustment = yAdjustment = labelDisplacement;
        labelY = yPos + yAdjustment;
        cursor = config.link ? POINTER : config.allowDrag ? 'move' : BLANKSTRING;

        plotLabelStyle = config.dataLabelStyle;
        labelAttrs = {
          text: smartTextObj.text,
          title: (smartTextObj.tooltext || BLANKSTRING),
          fill: plotLabelStyle.color,
          'text-bound': [plotLabelStyle.backgroundColor, plotLabelStyle.borderColor,
            style.borderThickness, style.borderPadding,
            style.borderRadius, style.borderDash
          ],
          x: xPos,
          y: labelY,
          cursor: cursor
        };

        labelElement = setGraphics.label;

        labelElement = animationManager.setAnimation({
          el: labelElement || 'text',
          attr: labelAttrs,
          container: group,
          component: dataset
        });
        labelElement.outlineText(conf.showTextOutline, labelAttrs.fill);
        if (!setGraphics.label) {
          labelElement = dataset.addGraphicalElement('plotLabel', labelElement, true);
          setGraphics.label = labelElement;

          // If dragging is allowed for that node then only we bind drag functions to the labelElement
          labelElement.drag(dragMove, dragStart, dragUp);
        } else {
          labelElement.show();
        }

        setElement = setGraphics && (setGraphics.image || setGraphics.element);

        if (cloneText) {
          animationManager.setAnimation({
            el: cloneText,
            attr: {
              transform: BLANKSTRING,
              x: xPos,
              y: labelY,
              text: smartTextObj.text,
              title: (smartTextObj.tooltext || BLANKSTRING),
              fill: style.color,
              'text-bound': [style.backgroundColor, style.borderColor,
                style.borderThickness, style.borderPadding,
                style.borderRadius, style.borderDash
              ]
            },
            component: dataset
          });
        }

        labelElement.data('drag-options', {
          dataObj: set,
          dataset: dataset,
          datasetIndex: datasetIndex,
          pointIndex: set.config.index,
          cursor: cursor,
          chart: chart,
          link: set.link
        });
        eventArgs = {
          index: i,
          link: config.link,
          y: config.y,
          x: config.x,
          shape: pluck(shapeType, 'rect'),
          width: config.width,
          height: config.height,
          radius: config.radius,
          sides: config.numSides,
          label: config.displayValue,
          toolText: config.toolText,
          id: config.id,
          datasetIndex: datasetIndex,
          datasetName: dataset.config.JSONData.seriesname,
          sourceType: 'dataplot',
          allowDrag: config.allowDrag,
          numSides: config.numSides,
          imageNode: config.imageNode,
          imageAlign: config.imageAlign,
          imageWidth: config.imageWidth,
          imageHeight: config.imageHeight,
          labelAlign: config.labelAlign,
          color: config.color,
          alpha: config.alpha,
          hoverColor: config.rollOverProperties.rollOverAttrs.rawhoverColor,
          hoverAlpha: config.rollOverProperties.rollOverAttrs.rawhoverAlpha,
          borderHoverColor: config.rollOverProperties.rollOverAttrs.rawhoverBorderColor,
          borderHoverAlpha: config.rollOverProperties.rollOverAttrs.rawhoverBorderAlpha,
          borderHoverThickness: config.rollOverProperties.rollOverAttrs['stroke-width'],
          hoverHeight: config.rollOverProperties.rollOverAttrs.height,
          hoverWidth: config.rollOverProperties.rollOverAttrs.width,
          hoverRadius: config.rollOverProperties.rollOverAttrs.r
        };

        groupId = datasetIndex + '_' + i;
        labelElement.data(GROUPID, groupId);
        labelElement.data(EVENTARGS, eventArgs);
        labelElement.data('hoverAttr', rollOverProperties && rollOverProperties.rollOverAttrs);
        labelElement.data('unHoverAttr', setElement.data('unHoverAttr'));
      } else {
        setGraphics.label && setGraphics.label.hide();
      }
    }
  }

  /**
   * Parses plot cosmetics and calculates position
   *
   * @param {any} i index
   * @memberof DragNodeDataset
   */
  parsePlotAttributes (i) {
    var dataset = this,
      datasetIndex = dataset.config.datasetIndex,
      datasetComponents = dataset.components,
      nodes = datasetComponents.nodes,
      xAxis = dataset.getFromEnv('xAxis'),
      yAxis = dataset.getFromEnv('yAxis'),
      data = datasetComponents.data,
      set = data[i],
      config = set.config,
      conf = dataset.config,
      xPos,
      yPos,
      setGraphics = set.graphics || (set.graphics = {}),
      symbol = config.symbol,
      width,
      height,
      radius,
      id,
      imageNode,
      confShapeArg,
      imageURL,
      imageAlign,
      lineColor = conf.colorObj.lineColor,
      lineWidth = conf.datasetPlotBorderThickness,
      plotWidth,
      plotHeight,
      isRectangle,
      rollOverProperties = set.config.rollOverProperties,
      imageWidth,
      imageHeight,
      imageY,
      pointAttr,
      fill,
      shapeType = config.shape,
      cursor = config.link ? POINTER : config.allowDrag ? 'move' : BLANKSTRING,
      rollOverAttrs,
      polypath,
      cloneImage = setGraphics.cloneImage,
      attr,
      cloneImageAttr,
      imageElementAttr;

    config._yPos = yPos = yAxis.getPixel(config.y);
    config._xPos = xPos = xAxis.getPixel(config.x);
    // only draw the point if y is defined
    if (yPos !== UNDEF && !isNaN(yPos)) {
      config.shapeArg = {};
      confShapeArg = config.shapeArg;
      height = pluckNumber(config.height);
      width = pluckNumber(config.width);
      radius = pluckNumber(config.radius);
      isRectangle = symbol === RECTANGLE;
      id = config.id;
      imageNode = config.imageNode;
      imageURL = config.imageURL;
      imageAlign = config.imageAlign; // TOP, MIDDLE or BOTTOM
      plotWidth = isRectangle ? width : radius * 1.4;
      imageWidth = pluckNumber(config.imageWidth, plotWidth);
      plotHeight = isRectangle ? height : radius * 1.4;
      imageHeight = pluckNumber(config.imageHeight, plotHeight);
      fill = toRaphaelColor(config.fillColor);
      config._plotWidth = plotWidth;
      config._plotHeight = plotHeight;
      pointAttr = {
        fill: fill,
        'stroke-width': lineWidth,
        stroke: toRaphaelColor(lineColor)
      };
      symbol = confShapeArg.symbol = pluck(config.symbol,
        conf.symbol, BLANK);
      symbol = symbol.split(UNDERSCORE);

      polypath = [symbol[1], xPos, yPos, config.radius, config.startAngle, 0];

      if (symbol[0] === 'poly' || symbol[0] === CIRCLE) {
        config.shapeType = symbol[0];
        config.elemType = PATH;
        // convert polypath to path
        attr = {
          path: polyPathToPath(polypath)
        };
        confShapeArg.x = xPos;
        confShapeArg.y = yPos;
        confShapeArg.radius = config.radius;
        confShapeArg.sides = symbol[1];
        pointAttr.r = config.radius;
        delete pointAttr.width;
        delete pointAttr.x;
        delete pointAttr.y;
        delete pointAttr.height;
        if (rollOverProperties && rollOverProperties.enabled) {
          rollOverAttrs = rollOverProperties.rollOverAttrs;
          delete rollOverAttrs.x;
          delete rollOverAttrs.y;
          delete rollOverAttrs.width;
          delete rollOverAttrs.height;
        }
      } else {
        config.shapeType = SHAPE_RECT;
        config.elemType = SHAPE_RECT;
        confShapeArg.x = xPos - (width / 2);
        confShapeArg.y = yPos - (height / 2);
        confShapeArg.r = 0;
        confShapeArg.width = width;
        confShapeArg.height = height;
        attr = {
          x: confShapeArg.x,
          y: confShapeArg.y,
          width: width,
          height: height,
          r: 0
        };
        pointAttr.width = width;
        pointAttr.height = height;
        pointAttr.x = xPos - (width / 2);
        pointAttr.y = yPos - (height / 2);
        // Readjust x and y of the rectangle if hover width or height is
        // changed
        if (rollOverProperties && rollOverProperties.enabled) {
          rollOverAttrs = rollOverProperties.rollOverAttrs;
          rollOverAttrs.x = xPos - (rollOverAttrs.width / 2);
          rollOverAttrs.y = yPos - (rollOverAttrs.height / 2);
          delete rollOverAttrs.r;
        }
      }

      attr.fill = fill;
      attr['stroke-width'] = lineWidth;
      attr.stroke = toRaphaelColor(lineColor);

      config.eventArgs = {
        index: i,
        link: config.link,
        y: config.y,
        x: config.x,
        shape: pluck(shapeType, 'rect'),
        width: width,
        height: height,
        radius: radius,
        sides: config.numSides,
        label: config.displayValue,
        toolText: config.toolText,
        id: config.id,
        datasetIndex,
        datasetName: dataset.config.JSONData.seriesname,
        sourceType: 'dataplot',
        allowDrag: config.allowDrag,
        numSides: config.numSides,
        imageNode: config.imageNode,
        imageAlign: config.imageAlign,
        imageWidth: config.imageWidth,
        imageHeight: config.imageHeight,
        labelAlign: config.labelAlign,
        color: config.color,
        alpha: config.alpha,
        hoverColor: config.rollOverProperties.rollOverAttrs.rawhoverColor,
        hoverAlpha: config.rollOverProperties.rollOverAttrs.rawhoverAlpha,
        borderHoverColor: config.rollOverProperties.rollOverAttrs.rawhoverBorderColor,
        borderHoverAlpha: config.rollOverProperties.rollOverAttrs.rawhoverBorderAlpha,
        borderHoverThickness: config.rollOverProperties.rollOverAttrs['stroke-width'],
        hoverHeight: config.rollOverProperties.rollOverAttrs.height,
        hoverWidth: config.rollOverProperties.rollOverAttrs.width,
        hoverRadius: config.rollOverProperties.rollOverAttrs.r
      };

      // Draw the imageNode if available
      if (imageNode && imageURL) {
        if (imageHeight > plotHeight) {
          imageHeight = plotHeight;
        }
        if (imageWidth > plotWidth) {
          imageWidth = plotWidth;
        }
        switch (imageAlign) {
          case POSITION_MIDDLE:
            imageY = yPos - (imageHeight / 2);
            break;
          case POSITION_BOTTOM:
            imageY = plotHeight > imageHeight ? yPos +
              (plotHeight / 2) - imageHeight
              : yPos - imageHeight / 2;
            break;
          default:
            imageY = plotHeight > imageHeight
              ? yPos - (plotHeight * 0.5)
              : yPos - imageHeight / 2;
            break;
        }
        config.imageX = xPos - (imageWidth / 2);
        config.imageY = imageY;
        config.imageWidth = imageWidth;
        config.imageHeight = imageHeight;

        imageElementAttr = {
          src: imageURL,
          x: config.imageX,
          y: imageY,
          width: imageWidth,
          height: imageHeight,
          cursor: cursor
        };
        if (cloneImage) {
          cloneImageAttr = {
            transform: BLANKSTRING,
            src: imageURL,
            x: config.imageX,
            y: imageY,
            width: imageWidth,
            height: imageHeight
          };
        }
      }
      config.pointAttr = pointAttr;
      nodes[id] = set;
      config.props = {
        element: {
          attr: attr
        },
        imageElement: {
          attr: imageElementAttr
        },
        cloneImage: {
          attr: cloneImageAttr
        },
        cloneGraphic: {
          attr: attr
        }
      };
    }
  }
  /**
   * Allocates position and parses cosmetics during post space management
   * @param  {Number} index Specific node whose node that is to be updated.
   */
  allocatePosition (index) {
    var dataset = this,
      data = dataset.components.data,
      i,
      len;

    len = data.length;
    if (index !== UNDEF) {
      dataset.parsePlotAttributes(index);
    } else {
      for (i = 0; i < len; i++) {
        dataset.parsePlotAttributes(i);
      }
    }
  }
  /**
   * Draw the individual nodes of the dataset
   * @param {number} i The index of the node that is to be drawn
   */
  _drawNode (i) {
    var dataset = this,
      chart = dataset.getFromEnv('chart'),
      datasetIndex = dataset.config.datasetIndex,
      manager = dataset.getLinkedParent(),
      datasetComponents = dataset.components,
      animationManager = dataset.getFromEnv('animationManager'),
      data = datasetComponents.data,
      set = data[i],
      config = set.config,
      setGraphics = set.graphics || (set.graphics = {}),
      groupId,
      imageNode = config.imageNode,
      imageURL = config.imageURL,
      group = dataset.getContainer('nodesGroup'),
      rollOverProperties = set.config.rollOverProperties,
      dragUp = dataset.dragUp,
      dragMove = dataset.dragMove,
      dragStart = dataset.dragStart,
      cursor = config.link ? POINTER : config.allowDrag ? 'move' : BLANKSTRING,
      type,
      setElement = setGraphics.graphic,
      cloneText = setGraphics.cloneText,
      cloneGraphic = setGraphics.cloneGraphic,
      cloneImage = setGraphics.cloneImage,
      imageElement = setGraphics.image,
      labelElement = setGraphics.label,
      visible = dataset.getState('visible');

    // only draw the point if y is defined
    if (config._yPos !== UNDEF && !isNaN(config._yPos)) {
      setElement = setGraphics.element;
      type = setElement && setElement.type;
      if (config.elemType.indexOf(type) === -1 && setElement) {
        setElement.remove();
        setElement = setGraphics.element = null;
        labelElement && labelElement.remove();
        imageElement && imageElement.remove();
        delete setGraphics.label;
        delete setGraphics.image;
        imageElement = null;
        labelElement = null;
      }
      setElement = animationManager.setAnimation({
        el: setElement || config.elemType,
        label: 'node',
        attr: config.props.element.attr,
        container: group,
        component: dataset
      });
      // Create a new element
      if (!setGraphics.graphic) {
        // If dragging is allowed for that node then only we bind drag functions to the setElement
        setElement.drag(dragMove, dragStart, dragUp);
      }
      setGraphics.element = setElement;
      setElement.show();
      manager.animationDone = true;

      groupId = datasetIndex + '_' + i;

      if (cloneGraphic) {
        if (cloneGraphic.type === setElement.type) {
          animationManager.setAnimation({
            el: cloneGraphic,
            attr: config.props.element.attr,
            component: dataset
          }).transform(BLANKSTRING);
        } else {
          cloneGraphic.remove();
          delete set.graphics.cloneGraphic;
          if (cloneText) {
            cloneText.remove();
            delete set.graphics.cloneText;
          }
        }
      }

      // Draw the imageNode if available
      if (imageNode && imageURL) {
        imageElement = animationManager.setAnimation({
          el: setGraphics.image || 'image',
          attr: visible && config.props.imageElement.attr,
          doNotRemove: true,
          container: group,
          component: dataset,
          callback: !visible && hideFn
        });
        if (!setGraphics.image && imageElement) {
          // If dragging is allowed for that node then only
          // we bind drag functions to the imageElement
          imageElement.drag(dragMove, dragStart, dragUp);
        }
        setGraphics.image = imageElement;
        visible && imageElement.show();

        imageElement.data('drag-options', {
          dataObj: set,
          dataset: dataset,
          datasetIndex: dataset.index,
          pointIndex: set.config.index,
          cursor: cursor,
          link: set.link
        });

        imageElement.data(GROUPID, groupId);
        imageElement.data(EVENTARGS, config.eventArgs);
        imageElement.data('hoverAttr', rollOverProperties && rollOverProperties.rollOverAttrs);
        imageElement.data('unHoverAttr', config.pointAttr);

        if (cloneImage) {
          animationManager.setAnimation({
            el: cloneImage,
            attr: config.props.cloneImage.attr,
            component: dataset
          });
        }
      } else if (setGraphics.image) {
        setGraphics.image = animationManager.setAnimation({
          el: setGraphics.image,
          component: dataset
        });
      }
      dataset.drawLabel(i);
      animationManager.setAnimation({
        el: setElement,
        attr: { cursor: cursor },
        component: dataset
      });

      setElement.data('drag-options', {
        dataObj: set,
        dataset: dataset,
        datasetIndex: dataset.index,
        pointIndex: set.config.index,
        cursor: cursor,
        chart: chart,
        link: set.link
      });
      setElement.data(GROUPID, groupId);
      setElement.data(EVENTARGS, config.eventArgs);
      setElement.data('hoverAttr', rollOverProperties && rollOverProperties.rollOverAttrs);
      setElement.data('unHoverAttr', config.pointAttr);

      visible ? setElement.show() : setElement.hide();
    } else {
      setGraphics.element && (setGraphics.element = animationManager.setAnimation({
        el: setGraphics.element,
        component: dataset
      }));
      setGraphics.image && (setGraphics.image = animationManager.setAnimation({
        el: setGraphics.image,
        component: dataset
      }));
      setGraphics.label && (setGraphics.label = animationManager.setAnimation({
        el: setGraphics.label,
        component: dataset
      }));
    }
  }

  /**
   * function to Remove data plots if the number of current data plots/categories
   * is more than the existing ones.
   * @param  {Object} datasetJSON JSON for dataset configurations
   */
  trimData (datasetJSON) {
    if (!this.config.JSONData) {
      return;
    }
    let dataSet = this,
      prevData = dataSet.components,
      prevDataLength = prevData.data && prevData.data.length,
      currDataLength = (datasetJSON.data && datasetJSON.data.length) || 0,
      dataDiff = prevDataLength - currDataLength;

    // Removing data plots if the number of current data plots/categories
    // is more than the existing ones.
    if (dataDiff > 0) {
      dataSet.removeData(currDataLength, dataDiff);
    }
  }

  /**
   * Function to remove data during update if number of data has reduced than the previous render
   * @param {number} indexVal The data index from which data has to be removed.
   * @param {number} stretchVal The index upto which data has to be removed
   */
  removeData (indexVal, stretchVal) {
    var dataSet = this,
      index = indexVal,
      stretch = stretchVal,
      components = dataSet.components,
      manager = dataSet.getLinkedParent(),
      dataStore = components.data,
      removeDataArr = components.removeDataArr || (components.removeDataArr = []);

    stretch = stretch || 1;
    index = index || 0;

    if (index < 0) {
      index = 0;
    }
    components.removeDataArr = removeDataArr = removeDataArr.concat(dataStore.splice(index, stretch));
    manager._clearConnectors();
  }

  /**
   * Function to remove graphics during update if number of data has reduced than the previous render
   * @param {Object} dataObj The object corresponding to the data whose graphics has to be removed
   */
  _removeDataVisuals (dataObj) {
    var dataSet = this,
      ele,
      graphics,
      graphicsObj;
    if (!dataObj) {
      return;
    }
    graphics = dataObj.graphics;
    for (ele in graphics) {
      graphicsObj = graphics[ele];

      if (graphicsObj.hide && typeof graphicsObj.hide === 'function') {
        dataSet.getFromEnv('animationManager').setAnimation({
          el: graphicsObj,
          attr: { 'text-bound': [] },
          component: dataSet
        });
        graphicsObj.hide();
        graphicsObj.transform && graphicsObj.transform(BLANKSTRING);
      }
    }
  }

  /**
   * Get json data of dragnode dataset
   * @return {Object} jsonData
   */
  getJSONData () {
    var dataset = this,
      dataStore = dataset.components.data,
      len = dataStore.length,
      jsonData = [],
      dataObj,
      i;
    for (i = 0; i < len; i++) {
      dataObj = dataStore[i];
      if (!dataObj.removed) {
        if (dataObj.config._options) {
          delete dataObj.config._options.update;
          delete dataObj.config._options.add;
          jsonData.push(dataObj.config._options);
        }
      }
    }
    return jsonData;
  }
}
export default DragNodeDataset;
